import { Globe } from "lucide-react";

export const GlobalDiasporaSection = () => {
  return (
    <section 
      className="py-16 md:py-24 lg:py-32 bg-[#0A0A0B] relative overflow-hidden"
      data-testid="global-diaspora-section"
    >
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
      
      {/* Corner accents */}
      <div className="absolute top-12 left-12 w-20 h-20 border-l border-t border-[#D4AF37]/15 hidden lg:block" />
      <div className="absolute bottom-12 right-12 w-20 h-20 border-r border-b border-[#D4AF37]/15 hidden lg:block" />
      
      <div className="relative z-10 max-w-4xl mx-auto px-5 md:px-8 lg:px-12 text-center">
        {/* Icon */}
        <div className="w-16 h-16 md:w-20 md:h-20 border border-[#D4AF37]/30 flex items-center justify-center mx-auto mb-6 md:mb-8">
          <Globe className="w-8 h-8 md:w-10 md:h-10 text-[#D4AF37]" />
        </div>
        
        {/* Header */}
        <span className="text-[#D4AF37] text-xs md:text-sm tracking-[0.2em] md:tracking-[0.3em] uppercase font-semibold">
          International Reach
        </span>
        <h2 className="font-['Playfair_Display'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl text-white mt-4 md:mt-6 leading-tight">
          Trusted by Investors Across
          <span className="block text-[#D4AF37] italic">the Global Diaspora</span>
        </h2>
        <div className="w-16 md:w-20 h-px bg-[#D4AF37] mx-auto mt-6 md:mt-8 mb-8 md:mb-10" />
        
        {/* Description */}
        <p className="text-white/60 text-sm md:text-base lg:text-lg leading-relaxed mb-8 md:mb-10">
          4 ACES Attorneys regularly advises international investors seeking secure property 
          acquisitions in Nigeria. Our firm works with diaspora clients who require trusted 
          legal oversight when investing remotely.
        </p>
        
        {/* Regions highlight */}
        <div className="bg-[#D4AF37]/10 border border-[#D4AF37]/20 p-5 md:p-6 mb-8 md:mb-10">
          <p className="text-white text-sm md:text-base lg:text-lg font-medium">
            Our clients include investors based in the <span className="text-[#D4AF37]">United Kingdom</span>, <span className="text-[#D4AF37]">United States</span>, <span className="text-[#D4AF37]">Canada</span>, the <span className="text-[#D4AF37]">Middle East</span>, and across <span className="text-[#D4AF37]">Europe</span>.
          </p>
        </div>
        
        {/* Trust statement */}
        <p className="text-white/50 text-sm md:text-base italic leading-relaxed max-w-2xl mx-auto">
          We provide clear legal guidance, independent verification of property titles, and 
          structured transaction support to ensure every investment is legally protected.
        </p>
      </div>
      
      {/* Decorative bottom line */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />
    </section>
  );
};
